export default class YouTubePlayer {
  constructor(iframeId) {
    this.iframeId = iframeId;

    this.player = new window.YT.Player(iframeId, { // eslint-disable-line no-new
      events: {
        onReady: this.onPlayerReady
      }
    });
  }

  stopVideo = () => {
    document.getElementById(this.iframeId)
      .contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
  };

  playVideo = () => {
    document.getElementById(this.iframeId)
      .contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  };

  onPlayerReady = (event) => {
    event.target.playVideo();
  };

  static initialize = () => {
    const firstScriptTag = document.getElementsByTagName('script')[0];
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };
}
